import React, { useState } from "react";
import { connect } from "react-redux";
import * as R from "ramda";
import TextField from "@material-ui/core/TextField";
import { actions } from "EventLight/Sessions/PortalSessionModal/model";
import { WithFormInstanceProvider } from "ui-kit/Form/View";
import { getters as TabGetters } from "ui-kit/Tabs";
import { SESSION_FORM_ID } from "EventLight/Sessions/PortalSessionModal/constants";
import {
  TABS,
  SESSION_MODAL_TABS_INSTANCE_ID
} from "EventLight/Sessions/PortalSessionModal/constants";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
// import { getSelectedFieldsMessage } from "Orders/ImportModal/selectors/selectItems";

const useStyles = makeStyles({
  textFieldRoot: {
    width: "100%",
    border: " 1px solid #F2F2F2",
    borderRadius: "4px"
  },
  sendMessageSection: {
    display: "flex",
    flexDirection: "row",
    alignContent: "center",
    justifyContent: "space-between",
    marginBottom: 10,
    marginTop: 10,
    marginLeft: "10px"
  },
  sendButtonRoot: {
    backgroundColor: "#1e62d8",
    borderRadius: "4px",
    color: "white",
    fontSize: "12px",
    lineHeight: "17.5px",
    fontSizeAdjust: "14px",
    minHeight: "40px",
    minWidth: "100px",
    marginLeft: "10px"
  }
});

const decorate = R.compose(
  WithFormInstanceProvider(R.always(SESSION_FORM_ID)),
  connect(
    state => ({
      activeTab: TabGetters.selectedTab(state, {
        instanceId: SESSION_MODAL_TABS_INSTANCE_ID
      })
    }),
    {
      sendMessage: actions.sendMessage
    }
  )
);

const Footer = ({ activeTab, sendMessage }) => {
  const [message, setMessage] = useState("");
  const classes = useStyles();
  const send = () => {
    sendMessage(message);
    setMessage("");
  };

  if (activeTab === TABS.MESSAGES) {
    return (
      <div className={classes.sendMessageSection}>
        <div style={{ width: "85%" }}>
          <TextField
            size="small"
            variant="outlined"
            placeholder="Enter your comment"
            classes={{ root: classes.textFieldRoot }}
            value={message}
            onChange={e => setMessage(e.target.value)}
          />
        </div>
        <div style={{ width: "15%" }}>
          <Button
            size="small"
            variant="contained"
            color="primary"
            disabled={!message}
            classes={{ root: classes.sendButtonRoot }}
            onClick={send}
          >
            Send
          </Button>
        </div>
      </div>
    );
  }

  return <></>;
};

export default decorate(Footer);
